import * as React from "react";
const SvgClientProfile = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={65}
    height={65}
    fill="none"
    {...props}
  >
    <circle cx={32.5} cy={32.5} r={32.5} fill="#FDB6B2" />
    <path
      fill="#D4635D"
      d="M23.118 32.926q0-2.652 1.196-4.758 1.195-2.131 3.25-3.328 2.08-1.196 4.602-1.196 2.964 0 5.174 1.43t3.224 4.056H37.73q-.754-1.638-2.184-2.522-1.404-.885-3.38-.884-1.897 0-3.406.884-1.508.884-2.366 2.522-.858 1.612-.858 3.796 0 2.158.858 3.796.858 1.613 2.366 2.496 1.507.885 3.406.884 1.976 0 3.38-.858 1.43-.885 2.184-2.522h2.834q-1.014 2.6-3.224 4.03-2.21 1.404-5.174 1.404-2.521 0-4.602-1.17a8.74 8.74 0 0 1-3.25-3.302q-1.196-2.106-1.196-4.758"
    />
  </svg>
);
export default SvgClientProfile;